import { HeaderBlock } from '@capsicum/common-web';
import { useWCPledgeCardTexts } from 'libs/features/nc-wallet/shared/src/hooks/useWCPledgeCardTexts';

import { WCPledgeCard } from './WCPledgeCard';

export const WCPledgeSection = () => {
	const { WCPledgeSectionTitle } = useWCPledgeCardTexts();

	return (
		<div>
			<HeaderBlock testID="worldChampionshipPledge-sectionTitle" title={WCPledgeSectionTitle} />
			<WCPledgeCard />
		</div>
	);
};
